import React, { useCallback } from 'react'
import clsx from 'clsx'
import { useStatsJoueursDataContext } from '../../../contexts/StatsJoueursDataContext'
import { STATS_JOUEUR_CONFIG } from '../../../config/statsJoueurConfig'
import usePagination, { UsePaginationItem, UsePaginationProps } from '@mui/material/usePagination'
import styles from './styles.module.scss'

const ICON_CLASS_MAPPING: { [x in UsePaginationItem['type']]?: string } = {
    first: 'fi-rs-angle-double-small-left',
    last: 'fi-rs-angle-double-small-right',
    previous: 'fi-rs-angle-small-left',
    next: 'fi-rs-angle-small-right',
}

const ICON_BUTTON_TITLE: { [x in UsePaginationItem['type']]?: string } = {
    first: 'Première page',
    last: 'Dernière page',
    previous: 'Page précédente',
    next: 'Page suivante',
}

const getNumberLength = (num: number) => Math.ceil(Math.log10(num + 1))

export const Pagination = () => {
    const { page, setPage, rows, isDesktop } = useStatsJoueursDataContext()

    const pageCount = Math.ceil(rows.length / STATS_JOUEUR_CONFIG.PAGE_SIZE)
    const maxPageLength = getNumberLength(pageCount)

    const onChange: UsePaginationProps['onChange'] = useCallback(
        (_, p: number) => {
            setPage(p)
            window.scrollTo({
                top: 300, // todo: try to scroll to header
                behavior: 'smooth',
            })
        },
        [setPage],
    )

    const { items } = usePagination({
        count: pageCount,
        page,
        onChange,
        boundaryCount: isDesktop ? 1 : 0,

        showFirstButton: true,
        showLastButton: true,
    })

    if (rows.length <= STATS_JOUEUR_CONFIG.PAGE_SIZE)
        return <div style={{ height: isDesktop ? 60 : 40 }} />

    return (
        <div className={styles.pagination}>
            {items.map(({ page, type, selected, ...item }, index) => {
                if (type === 'start-ellipsis' || type === 'end-ellipsis') {
                    return (
                        <div key={index} className={styles.ellipsis}>
                            ...
                        </div>
                    )
                }

                if (type === 'first' || type === 'last' || type === 'previous' || type === 'next') {
                    return (
                        <button
                            key={index}
                            {...item}
                            className={styles.iconButton}
                            title={ICON_BUTTON_TITLE[type]}
                        >
                            <i className={`fi ${ICON_CLASS_MAPPING[type]}`}></i>
                        </button>
                    )
                }

                return (
                    <button
                        key={index}
                        {...item}
                        className={clsx(styles.page, selected && styles.selected)}
                    >
                        {String(page).padStart(maxPageLength, '0')}
                    </button>
                )
            })}
        </div>
    )
}
